module.exports = __webpack_public_path__ + "static/media/bg_continent.a2810939.jpg";